import {useEffect, useState} from "react";
import FeatureAppAPI from '~/api/featureAppApi';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesRight} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";

function FeatureAppSession(){
    const [features, setFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        FeatureAppAPI.getAll()
            .then((res) => {
                setFeatures(res.data);
                setLoading(false);
            })
            .catch((err) => {
                ;
            });
    }, []);
    return (
        <section className="pt-15 pb-0" id="feature">
            <div className="container-medium">
                <div className="position-relative z-2">
                    <div className="row">
                        <h4 className="text-primary fw-bolder mb-4">Features</h4>
                        <p className="mb-2 fs-8-1">Our system offers advanced chatbot features that serve as a gateway to unlocking the infinite well of wisdom within you. It is a tool that helps you reconnect with the forgotten fragments of your being, those parts of yourself that may have been lost or suppressed over time. Through this journey, you are invited to rediscover the depths of your soul, to bring back to life the voices that have been silenced, and to awaken a deeper understanding of who you truly are.
                        </p>
                    </div>
                    {
                        loading && (
                            <div className="mt-4">
                                <Skeleton height={10} count={5} containerClassName={"w-100"}/>
                            </div>
                        )
                    }
                    {
                        !loading &&
                        features.map((item, index) => {
                            return (
                                <div key={item.FeatureAppId} className="row mt-7 align-items-center justify-content-between text-center text-lg-start mb-6 mb-lg-0">
                                    <div className= { (index % 2 ==0) ? 'col-lg-5' : 'col-lg-5 order-0 order-lg-1'}>
                                        <img className="feature-image img-fluid mb-9 mb-lg-0 rounded-3" src={item.ThumbnailUrl} alt="img"/>
                                    </div>
                                    <div className="col-lg-6">
                                        <h3 className="fw-bolder mb-3 lh-sm">{item.Title}</h3>
                                        <p className="mb-4 px-md-7 px-lg-0 fs-8">{item.Description}</p>
                                        <ul className="list-unstyled">
                                            {
                                                item.FeatureAppDescriptions.map((item, index) => {
                                                    return (
                                                        <li className='pb-1 fs-8-1 fw-semibold' key={index}><i className="bi bi-check"></i> {item.Description}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    );
}

export default FeatureAppSession;